module.exports = __webpack_public_path__ + "media/images/svg/realestate/farm-10d05361741d3dc2c4770caceded2391.svg";